import WeeklyRoutines from './week';
import UpcomingWeeklyRoutines from './upcomingWeek';

const MyRoutine = () => {
  return (
    <div className='text-white'>
      <WeeklyRoutines />
      <UpcomingWeeklyRoutines />
    </div>
  );
};

export default MyRoutine;
